import { useBrand } from '../context/BrandContext';
import { Mail, Globe, ExternalLink } from 'lucide-react';

export default function BrandFooter() {
  const { brand } = useBrand();
  if (!brand) return null;
  const primary = brand.primary_color || '#0d63b0';
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-slate-200 bg-slate-50">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            {brand.logo_url ? (
              <img src={brand.logo_url} alt={brand.name} className="h-8 w-auto max-w-[160px] object-contain" onError={(e) => { e.currentTarget.style.display = 'none'; }} />
            ) : (
              <div className="h-8 w-8 rounded-lg flex items-center justify-center text-white font-bold text-xs" style={{ backgroundColor: primary }}>{brand.name?.[0]?.toUpperCase()}</div>
            )}
            <div>
              <div className="font-bold text-slate-900 text-sm">{brand.name}</div>
              <div className="text-[10.5px] uppercase tracking-widest font-semibold" style={{ color: primary }}>Secure Push</div>
            </div>
          </div>
          <div className="flex flex-wrap items-center gap-x-6 gap-y-1 text-xs text-slate-500">
            <span>© {year} {brand.name}. Tutti i diritti riservati.</span>
            {brand.company_url && (
              <a href={brand.company_url} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 hover:text-slate-800">
                <Globe className="h-3 w-3" /> Sito web <ExternalLink className="h-3 w-3" />
              </a>
            )}
          </div>
        </div>
        <div className="mt-4 text-center text-[11px] text-slate-400">
          Servizio di condivisione sicura protetto da cifratura AES-256 · GDPR compliant
        </div>
      </div>
    </footer>
  );
}
